<template>
  <el-upload
    :action="fullAction"
    multiple
    :show-file-list="showList"
    :file-list="fileList"
    :list-type="picture?'picture':'text'"
    :before-remove="beforeRemove"
    :on-remove="handleRemove"
    :on-progress="handleProgress"
    :on-success="handleSuccess"
    :on-error="handleError"
    :before-upload="beforeAvatarUpload"
  >
    <el-button icon="el-icon-upload" size="small" type="primary">{{text}}</el-button>
  </el-upload>
</template>
<script>
export default {
  name: "file-upload",
  data() {
    return {
      fullAction: "",
      fileList: [],
      loading: "",
      baseUrl: process.env.DOWNLOAD_URL 
    };
  },
  props: {
    action: "",
    text: {
      default: "点击上传"
    },
    picture: Boolean,
    showList: true,
    value: {
      default: () => []
    }
  },
  watch: {
    value(val) {
      if (!val) {
        return;
      }
      let arr = JSON.parse(JSON.stringify(val));
      this.fileList = arr.map(v => {
        v.url = this.baseUrl + v.url;
        return v;
      });
    }
  },
  methods: {
    beforeAvatarUpload(file) {
      const isOK = file.type === "image/jpeg" || file.type === "image/png";
      const isLt300M = file.size / 1024 / 1024 < 300;

      if (!isOK) {
        this.$message.error("上传附件只能是 JPG或PNG 格式!");
      }
      if (!isLt300M) {
        this.$message.error("上传附件大小不能超过 300MB!");
      }
      return isOK && isLt300M;
    },
    beforeRemove(file, fileList) {
      // return this.$confirm(`确定移除 ${file.name}？`);
    },
    handleRemove(file, fileList) {

      let _this = this;
      let arr = fileList.slice();
      arr.map(s => {
        s.url = s.url.replace(_this.baseUrl, "");
      });
      this.$emit("input", arr);
      
    },
    handleProgress() {
      this.loading = this.$loading({
        lock: true,
        text: "文件上传中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
    },
    handleSuccess(res, file, fileList) {
      this.loading.close();
      if (res.success) {
        this.$message({
          message: "上传成功",
          type: "success"
        });
      } else {
        this.$message({
          message: res.msg || "上传失败"
        });
        fileList.splice(fileList.length - 1, 1);
        return;
      }
      let _this = this;
      let arr = fileList.slice();
      let obj = {};
      obj.url = res.msg;
      obj.name = file.name;
      arr.splice(arr.indexOf(file), 1, obj);
      arr.map(s => {
        s.url = s.url.replace(_this.baseUrl, "");
      });
      this.$emit("input", arr);
    },
    handleError(err, file, fileList) {
      this.loading.close();
      fileList.splice(fileList.length - 1, 1);
      this.$message.error("上传失败");
    }
  },
  mounted() {
    // this.fullAction = this.baseUrl + this.action;
    this.fullAction = process.env.BASE_URL + this.action;
    this.fileList = JSON.parse(JSON.stringify(this.value));
  }
};
</script>



// WEBPACK FOOTER //
// src/components/file-upload.vue